<ng-container *ngrxLet="activeLanguage$ as activeLanguage">
    <ng-container *ngIf="activeLanguage === 'pl'">
        <p>
            Pod koniec 2024 roku PAŻP przeprowadził konsultacje w zakresie projektu dronowego "Rozbudowa i wyposażenie centrów kompetencji
            (specjalistyczne ośrodki szkoleniowe, ośrodki wsparcia wdrożeń, centra monitorowania) oraz infrastruktura do zarządzania ruchem
            pojazdów bezzałogowych jako ekosystem innowacji" .
        </p>
        <p>
            Użytkownicy mieli możliwość wyrażenia swoich opinii w blisko 40 szczegółowych pytaniach. Uzyskane liczne informacje zwrotne,
            pozwoliły Agencji na dokonanie szeregu zmian optymalizujących projekt, tak aby jego cele mogły zostać osiągnięte w jak
            najwyższym stopniu.
        </p>
        <p>
            Bardzo dziękujemy Państwu za poświęcony czas – mamy nadzieję, że dostrzegą Państwo liczne zmiany, jakie zostały wprowadzone
            dzięki Państwa opiniom.
        </p>
        <h4>Główne wnioski:</h4>
        <ul>
            <li>Szacowany wpływ projektu na rozwój rynku BSP oceniony został na wysoki.</li>
            <li>Wszystkie przedstawione funkcjonalności usług cyfrowych zostały wysoko ocenione.</li>
            <li>
                Większy nacisk powinien zostać położony na premiowanie lokalizacji, z wysokim potencjałem popytowym, nawet kosztem tego, że
                w takich miejscach trudniej będzie uzyskać zezwolenie na loty w kategorii szczególnej. Poparcie dla planowanych wdrożeń, ale
                duża część ankietowanych uważa, że potencjał popytowy powinien odgrywać jeszcze wyższą rolę, niż ta zawarta w
                przedstawionych w kryteriach oceny
            </li>
            <li>
                Ankietowani pozytywnie ocenili propozycję PAŻP włączenia ich w proces oceniania obszarów, w których miałyby zostać utworzone
                CK (usługi cyfrowe), jak również w proces wyłaniania miejsc w których miałyby powstać Ośrodki (obiekty poligonowo –
                szkoleniowe)
            </li>
            <li>Ośrodki nie powinny być tworzone w każdym CK, ale tylko w lokalizacjach cechujących się wysokim potencjałem popytowym.</li>
            <li>
                Rynek spodziewa się popytu na usługi szkoleniowe czy demonstracje produktów i usług, ale silnie uzależnia jego skalę od
                lokalizacji Ośrodków. W/w wydarzenia w Ośrodkach powinny być głównie organizowane eventowo.
            </li>
        </ul>

        <h4>Dokonane przez PAŻP zmiany w zakresie konkursu CK:</h4>
        <ul>
            <li>
                <strong>Uczestnikiem konkursu musi być Jednostka Samorządu Terytorialnego (JST)</strong>, jako przedstawiciel lokalnej
                społeczności.
            </li>

            <li>
                <strong
                    >JST będą mogły być uczestnikiem konkursu nie tylko tworząc konsorcja z podmiotami państwowymi, ale również z
                    prywatnymi.</strong
                >
            </li>

            <li><strong>Zwiększenie znaczenia kryteriów oceniających potencjalny popyt na loty / usługi BSP</strong></li>

            <li>
                <strong>Zwiększenie dopuszczalnego poziomu udziału w obszarze CK terenów o wyższym poziomie ryzyka naziemnego</strong>
                (średnio i gęsto zaludnionych). Modyfikacje kryteriów oceny zostały wprowadzone z uwzględnieniem planowanych zmian w SORA
                2.5 pod kątem ryzyka naziemnego (W rezultacie prac analitycznych JARUS nad dokumentacją do wersji SORA 2.5 otrzymano wyniki,
                które pozwoliły dwukrotnie zwiększyć przedziały ludności bez zmiany ryzyka dla operacji, aktualnie EASA pracuję nad
                wdrożeniem wersji SORA 2.5 w UE).
            </li>

            <li>
                <strong>Ilość tworzonych w ramach projektu Ośrodków CK została zredukowana</strong> – będą wybierane tylko w tych
                lokalizacjach, które zdaniem PAŻP i Użytkowników mają najwyższy potencjał popytowy
            </li>

            <li>
                <strong
                    >PAŻP wycofał z Regulaminu i Kryteriów Oceny wymóg złożenia przez JST deklaracji działki / nieruchomości pod utworzenie
                    Ośrodków CK</strong
                >
                (część JST nie dysponuje takimi nieruchomościami). Deklaracje będą zbierane podczas konkursu, ale nie będzie to miało
                żadnego wpływu na sam proces wyboru obszarów, w których zostaną utworzone CK.
            </li>

            <li>
                <strong>Zmianie ulegnie sposób wyłaniania laureatów konkursu</strong> (mniej grup województw > większa konkurencja > wybór
                lokalizacji z większym potencjałem popytowym). Dzięki zmianie, uczestnicy, którzy trafili do silnej grupy, ale zostali
                ocenieni wysoko (liczba punktów), będą mogli zostać laureatami Konkursu jako „lucky loser” (szczęśliwy przegrany).
            </li>

            <li>
                <strong
                    >PAŻP włączy przedstawicieli rynku dronowego (Użytkownicy systemu KSID) w proces oceny lokalizacji na CK (obszar
                    działania systemu) zgłaszanych w konkursie</strong
                >. Po zebraniu wszystkich wniosków od Uczestników przeprowadzone zostanie głosowanie, którego wyniki zostaną uwzględnione w
                końcowych ocenach zgłoszonych wniosków konkursowych.
            </li>

            <li>
                <strong>Przedstawiciele rynku dronowego</strong> (użytkownicy systemu KSID oraz podmioty znajdujące się na Liście Operatorów
                Szkolących prowadzonej przez Prezesa ULC)
                <strong>zostaną włączeni w proces wyłaniania lokalizacji do utworzenia Ośrodków</strong>.
            </li>
        </ul>

        <p>
            Szczegółowe informacje na temat wyników ankiety -
            <a [href]="SUMMARY_FILE_URL" download target="_blank" class="button-link">tutaj</a>
        </p>

        <h4>Zebranie opinii od użytkowników</h4>

        <p>
            Równocześnie PAŻP podczas konsultacji zebrał opinie od użytkowników na temat ewentualnych nowych, przyszłych inicjatyw
            związanych z rynkiem BSP. Ocenie poddane zostały różne propozycje (nie znajdujące się w projekcie KPO) w zakresie dofinansowania
            rynku, mogące znacząco przyczynić się do dalszego rozwoju sektora dronowego w Polsce.
        </p>

        <p>
            Jako pożądane ocenione zostały zarówno inicjatywy dotyczące dofinansowania szkoleń, jak również urządzeń trackingowych dla BSP.
            Równocześnie użytkownicy, zwracając uwagę na istniejącą obecnie barierę dla możliwości realizacji zaawansowanych lotów BVLOS w
            terenach mocniej zurbanizowanych, zgłosili propozycję dofinansowania DVR (poświadczenie bezpieczeństwa wytwarzanych konstrukcji
            BSP).
        </p>

        <p>
            Nowe zagadnienia, które spotkały się z pozytywnym odbiorem przez Ankietowanych związane z programami dofinansowania, nie mogły
            zostać włączone do przedmiotowego projektu KPO. Dlatego Agencja przygotowała osobną dokumentację projektową związaną z tą
            tematyką, która obecnie jest przedmiotem wewnętrznych i zewnętrznych analiz w zakresie znalezienia formuły, w jakiej tego typu
            projekt mógłby w przyszłości zostać sfinansowany.
        </p>
    </ng-container>
    <ng-container *ngIf="activeLanguage === 'en'">
        <p>
            At the end of 2024, PANSA conducted consultations on the drone project "Expansion and equipping of competence centers
            (specialized training centers, implementation support centers, monitoring centers) and infrastructure for unmanned vehicle
            traffic management as an innovation ecosystem".
        </p>
        <p>
            Stakeholders had the opportunity to express their opinions in nearly 40 detailed questions. The numerous feedback received
            allowed PANSA to make a number of changes to optimize the project so that its goals could be achieved to the highest extent
            possible.
        </p>
        <p>Thank you very much for your time – we hope you will notice the numerous changes that have been made thanks to your feedback.</p>
        <h4>Main conclusions:</h4>
        <ul>
            <li>The estimated impact of the project on the development of the UAV market was rated as high.</li>
            <li>All presented functionalities of digital services were highly rated.</li>
            <li>
                Greater emphasis should be placed on prioritizing locations with high demand potential, even at the cost of it being more
                difficult to obtain flight permits in the specific category in such places. Support for planned implementations has been
                highlighted, however a large part of respondents believe that demand potential should play an even greater role than that
                included in the presented evaluation criteria
            </li>
            <li>
                Respondents positively evaluated PANSA's proposal to include them in the process of evaluating areas where Competence
                Centers (digital services) would be created, as well as in the process of selecting locations where Centers (training and
                testing facilities) would be established.
            </li>
            <li>Centers should not be created in every Competence Center, but only in locations with high demand potential.</li>
            <li>
                The market expects demand for training services or product and service demonstrations, but strongly depends on the location
                of the Centers. The above-mentioned events in the Centers should mainly be organized as events.
            </li>
        </ul>

        <h4>Changes made by PANSA regarding the Competence Center competition:</h4>
        <ul>
            <li>
                <strong>The competition participant must be a Local Government Unit (LGU)</strong>, as a representative of the local
                community.
            </li>

            <li>
                LGUs will be able to participate in the competition not only by
                <strong>forming consortia with state entities but also with private ones. </strong>
            </li>

            <li>Increasing the importance of criteria evaluating potential <strong>demand for UAV flights/services</strong></li>

            <li>
                <strong>Increasing the permissible level of Competence Center areas with higher ground risk </strong> (medium and densely
                populated areas). Evaluation criteria modifications were introduced considering the planned changes in SORA 2.5 regarding
                ground risk (As a result of JARUS's analytical work on the SORA 2.5 documentation, results were obtained that allowed the
                population ranges to be doubled without changing the risk for operations, currently EASA is working on implementing SORA 2.5
                in the EU).
            </li>

            <li>
                <strong>The number of Centers developed within the project has been reduced</strong> – they will be selected only in
                locations that, according to PANSA and Stakeholders, have the highest demand potential.
            </li>

            <li>
                <strong>
                    PANSA has removed from the Regulations and Evaluation Criteria the requirement for LGUs to submit a declaration of
                    land/property for the creation of Competence Center Centers
                </strong>
                (some LGUs do not have such properties). Declarations will be collected during the competition, but this will have no impact
                on the process of selecting areas where Competence Center will be created.
            </li>

            <li>
                <strong>The method of selecting competition winners will change</strong> (fewer groups of provinces > greater competition >
                selection of locations with greater demand potential). Thanks to the change, participants who were in a strong group but
                were rated highly (number of points) will be able to become competition winners as "lucky losers".
            </li>

            <li>
                <strong> PANSA will include representatives of the drone market</strong> (National Drone Information System –
                <a href="http://www.drony.gov.pl" target="_blank">www.drony.gov.pl</a> users)
                <strong>in the process of evaluating Competence Center locations </strong>(system operation area)<strong>
                    submitted in the competition.
                </strong>
                After collecting all applications from participants, a vote will be held, the results of which will be considered in the
                final evaluations of the submitted competition applications.
            </li>

            <li>
                <strong
                    >Representatives of the drone market (National Drone Information System –<a
                        href="http://www.drony.gov.pl"
                        target="_blank"
                        >www.drony.gov.pl</a
                    >
                </strong>
                users and registered by the Polish Civil Aviation Authority UAV Training Centers)
                <strong>will be included in the process of selecting locations for the creation of Centers.</strong>
            </li>
        </ul>

        <p>
            Detailed information about the survey results -
            <a [href]="SUMMARY_FILE_URL" download target="_blank" class="button-link">here</a>
        </p>

        <h4>Gather users feedback</h4>

        <p>
            At the same time, during the consultations, PANSA gathered opinions from users on possible new, future initiatives related to
            the UAV market. Various proposals (not included in the NRP project) for market funding, which could significantly contribute to
            the further development of the drone sector in Poland, were evaluated.
        </p>

        <p>
            Both initiatives regarding the funding of training and drone tracking devices for UAVs were assessed as desirable. At the same
            time, users, noting the current barrier to the possibility of conducting advanced BVLOS flights in more urbanized areas,
            proposed funding for DVR (safety certification of manufactured UAV).
        </p>

        <p>
            Due to the fact that the above-mentioned issues related to funding programs could not be included in the NRP project, the Agency
            has prepared separate project documentation related to this topic, which is currently undergoing internal and external analyses
            to find a formula in which it could be financed in the future.
        </p>
    </ng-container>
</ng-container>
